import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  longText: {
    display: 'none',
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      display: 'inline',
    },
  },
}));

interface OpenPositionCardProps {
  count: number;
  className: string;
}

export default function PositionsCount({ count, className }: OpenPositionCardProps) {
  const classes = useStyles();
  const [verb, positionsTxt] = count === 1
    ? ['is', `${count} new position`]
    : ['are', `${count} new positions`];
  return (
    <Typography className={className}>
      <span className={classes.longText}>
        There
        {' '}
        {verb}
      </span>
      {' '}
      {positionsTxt}
      {' '}
      <span className={classes.longText}>
        for you
      </span>
    </Typography>
  );
}
